export const coreProgramsTimeLength: Record<number, number> = {
  0: 1.5, //Sunday
  1: 1.5, //Monday
  2: 1.25, //Tuesday
  3: 1.5, //Wednesday
  4: 1.25, //Thursday
}

/**
 * Returns the days of the week (as moment.js weekday numbers) that have Healing ALS sessions
 * for a given month.
 *
 * @param yearMonth - Month in YYYYMM format (e.g., 202511 for November 2025)
 * @returns Array of weekday numbers (0=Sunday, 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday)
 */
export const getDaysOfWeekForMonth = (yearMonth: number): number[] => {
  // November 2025: Tuesday, Wednesday, Thursday (no Monday)
  if (yearMonth === 202511) {
    return [2, 3, 4]
  }

  // December 2025: Tuesday, Wednesday, Thursday (no Monday)
  if (yearMonth === 202512) {
    return [2, 3, 4]
  }

  // January 2026 onwards: Tuesday, Thursday only
  if (yearMonth >= 202601) {
    return [2, 4]
  }

  // Before November 2025: Keep existing behavior
  // After Feb 2025 (202502): Monday, Tuesday, Thursday
  if (yearMonth > 202502) {
    return [1, 2, 4]
  }

  // Feb 2025 and earlier: Sunday, Monday, Thursday
  return [0, 1, 4]
}
